/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import PropTypes from 'prop-types';
import { Loc } from 'redux-react-i18n';
import IconButton from 'components/mediabay-ui/components/IconButton';
import Icon from 'components/mediabay-ui/components/Icon';
import {
  StyledFilter,
  Header,
  Container,
  StyledButton,
  LeftContainer,
  RightContainer,
  FilterHeading,
  GenresColumn,
  FilterColumn,
  CheckboxTitle,
  StyledCheckbox,
} from './StylesFilter';

class ContentFilter extends React.Component {
  static propTypes = {
    title: PropTypes.node.isRequired,
    getFilter: PropTypes.func.isRequired,
    currentLanguage: PropTypes.string.isRequired,
    filterData: PropTypes.shape({
      status: PropTypes.number,
      data: PropTypes.objectOf(PropTypes.array),
    }).isRequired,
    checkedData: PropTypes.shape({
      genresIds: PropTypes.arrayOf(PropTypes.string),
      contriesIds: PropTypes.arrayOf(PropTypes.string),
      yearsIds: PropTypes.arrayOf(PropTypes.string),
      languagesIds: PropTypes.arrayOf(PropTypes.string),
    }).isRequired,
    formHandler: PropTypes.func.isRequired,
    resetBtnHandler: PropTypes.func.isRequired,
    genresCheckboxHandler: PropTypes.func.isRequired,
    countriesCheckboxHandler: PropTypes.func.isRequired,
    yearsCheckboxHandler: PropTypes.func.isRequired,
    languagesCheckboxHandler: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      isContainerVisible: false,
    };

    this.toggleBtnHandler = this.toggleBtnHandler.bind(this);
    this.filterOutsideClickHandler = this.filterOutsideClickHandler.bind(this);
  }

  componentDidMount() {
    const { getFilter } = this.props;

    document.addEventListener('click', this.filterOutsideClickHandler);
    getFilter();
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.filterOutsideClickHandler);
  }

  toggleBtnHandler() {
    const { isContainerVisible } = this.state;

    this.setState({
      isContainerVisible: !isContainerVisible,
    });
  }

  filterOutsideClickHandler(e) {
    if (!this.filterRef.contains(e.target)) {
      this.setState({
        isContainerVisible: false,
      });
    }
  }

  render() {
    const {
      filterData,
      currentLanguage,
      checkedData,
      resetBtnHandler,
      formHandler,
      title,
      genresCheckboxHandler,
      countriesCheckboxHandler,
      yearsCheckboxHandler,
      languagesCheckboxHandler,
    } = this.props;
    const { isContainerVisible } = this.state;
    return (
      <StyledFilter ref={(filterRef) => { this.filterRef = filterRef; }}>
        <Header>
          <div style={{ display: 'flex' }}>
            <StyledButton onClick={this.toggleBtnHandler}>
              {
                isContainerVisible ? (
                  <Icon
                    icon="arrow-up"
                    width={16}
                    height={16}
                  />
                ) : (
                  <Icon
                    icon="arrow-down"
                    width={16}
                    height={16}
                  />
                )
              }
              <span style={{ marginLeft: 7 }}>
                <Loc locKey="filterLabel" />
              </span>
            </StyledButton>

            <StyledButton onClick={resetBtnHandler}>
              <Loc locKey="filterReset" />
            </StyledButton>
          </div>
          <div>
            {isContainerVisible ? <IconButton icon="close" onClick={this.toggleBtnHandler} /> : null}
          </div>
        </Header>
        <Container
          isContainerVisible={isContainerVisible}
          onChange={formHandler}
        >
          <LeftContainer>
            <FilterHeading level={3}>
              {title}
            </FilterHeading>

            <GenresColumn>
              {
                filterData.data.genres.map(genre => (
                  <label key={genre.id} htmlFor={genre.name.en}>
                    <StyledCheckbox
                      key={genre.id}
                      id={genre.name.en}
                      name={genre.id}
                      type="checkbox"
                      value={genre.id}
                      checked={checkedData.genresIds.indexOf(genre.id.toString()) !== -1}
                      onChange={genresCheckboxHandler}
                    />
                    <CheckboxTitle>
                      {genre.name[currentLanguage] || genre.name['ru']}
                    </CheckboxTitle>
                  </label>
                ))
              }
            </GenresColumn>
          </LeftContainer>

          <RightContainer>
            <div style={{ flex: '1 1 0' }}>
              <FilterHeading level={3}>
                <Loc locKey="country" />
              </FilterHeading>
              <FilterColumn>
                {
                  filterData.data.countries.map(country => (
                    <label key={country.id} htmlFor={country.name.en}>
                      <StyledCheckbox
                        key={country.id}
                        id={country.name.en}
                        name={country.id}
                        type="checkbox"
                        value={country.id}
                        checked={checkedData.countriesIds.indexOf(country.id.toString()) !== -1}
                        onChange={countriesCheckboxHandler}
                      />
                      <CheckboxTitle>
                        {country.name}
                      </CheckboxTitle>
                    </label>
                  ))
                }
              </FilterColumn>
            </div>

            <div style={{ flex: '1 1 0' }}>
              <FilterHeading level={3}>
                <Loc locKey="releaseYear" />
              </FilterHeading>
              <FilterColumn>
                {
                  filterData.data.years.map(year => (
                    <label key={year.id} htmlFor={year.year}>
                      <StyledCheckbox
                        key={year.id}
                        id={year.year}
                        name={year.id}
                        type="checkbox"
                        value={year.id}
                        checked={checkedData.yearsIds.indexOf(year.id.toString()) !== -1}
                        onChange={yearsCheckboxHandler}
                      />
                      <CheckboxTitle>
                        {year.year}
                      </CheckboxTitle>
                    </label>
                  ))
                }
              </FilterColumn>
            </div>

            <div style={{ flex: '1 1 0' }}>
              <FilterHeading level={3}>
                <Loc locKey="language" />
              </FilterHeading>
              <FilterColumn>
                {
                  filterData.data.languages.map(language => (
                    <label key={language.id} htmlFor={language.name}>
                      <StyledCheckbox
                        key={language.id}
                        id={language.name}
                        name={language.id}
                        type="checkbox"
                        value={language.id}
                        checked={checkedData.languagesIds.indexOf(language.id.toString()) !== -1}
                        onChange={languagesCheckboxHandler}
                      />
                      <CheckboxTitle>
                        {language.name}
                      </CheckboxTitle>
                    </label>
                  ))
                }
              </FilterColumn>
            </div>
          </RightContainer>
        </Container>
      </StyledFilter>
    );
  }
}

export default ContentFilter;
